var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit, TemplateRef, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PlayersService as PlayerService } from '../resultboard/draft/players/players.service';
import { UtilsService } from '../_services/utils.service';
import { RankemService } from '../_services/rankem.service';
import { LeagueRegPopupComponent } from './../league-reg-popup/league-reg-popup.component';
import { MainService } from 'src/app/_services/main.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { TournamentService } from './../tournamentpopup/tournament.service';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { ComponentCanDeactivate } from '../_guards/';
import { MatTabGroup } from '@angular/material';
var RankemComponent = /** @class */ (function () {
    function RankemComponent(spinner, _mainService, tournamentService, PlayersService, rankemService, dialog, _utilsService, store, route, router) {
        var _this = this;
        this.spinner = spinner;
        this._mainService = _mainService;
        this.tournamentService = tournamentService;
        this.PlayersService = PlayersService;
        this.rankemService = rankemService;
        this.dialog = dialog;
        this._utilsService = _utilsService;
        this.store = store;
        this.route = route;
        this.router = router;
        this.isMobile = false;
        this.games = {
            0: 'all',
            1: 'nhl',
            2: 'nfl',
            3: 'mlb',
            4: 'nba',
            5: 'pga'
        };
        this.myTeam = [];
        this.visibleQuickJoin = false;
        this.quickContests = [];
        this.isMyTeam = true;
        this.orderChnage = false;
        this.disableButton = false;
        this.mode = 'create';
        this.multiplier = '';
        this.curSort = '';
        this.curDir = 1;
        this.errors = "";
        this.selectedteam = 0;
        this.successMsg = "";
        this.searchString = '';
        this.searchTimer = null;
        this.showfpts = false;
        this.newTeam = false;
        this.isLoading = true;
        this.uploadURL = "" + environment.assetUploadURL + '/players/';
        this.total_number = 0;
        this.player_remainig = 0;
        this.baseURL = "" + environment.SITE_URL;
        this.bucketURL = "" + environment.assetURL + '/assets/default/images/';
        this.league_member_id = 0;
        this.parameters = { game_type: null, league_id: null, lgm_id: null };
        this.lgm_id = 0;
        this.user = null;
        this.selectedPlayers = [];
        this.eventOptions = {
            handle: '.myTmDeta',
            onEnd: function (e) {
                _this.orderChnage = true;
                var aa = _this.immutableMove(_this.selectedPlayers, e.oldIndex, e.newIndex);
                _this.checkDisabled();
            }
        };
        this.showPlayersTab = true;
        this.curTabClass = 'players';
        this.curTab = 'players';
        this.darkMode = false;
        this.darkMode_ext = '';
        this.currentLgmId = 0;
        this.filterStandings = function (user) {
            var regex = new RegExp(_this.searchString, 'gi');
            return (user.team_name.match(regex) != null);
        };
        this.filterPlayers = function (player) {
            if (_this.searchString != '' && _this.teamfilter != '') {
                var regex = new RegExp(_this.searchString, 'gi');
                var teamfregex = new RegExp(_this.teamfilter, 'gi');
                var fullName = player.fn + ' ' + player.ln;
                return ((player.fn.match(regex) != null || player.ln.match(regex) != null || fullName.match(regex) != null) && player.tn.match(teamfregex) != null);
            }
            else if (_this.searchString != '' && _this.teamfilter == '') {
                var regex = new RegExp(_this.searchString, 'gi');
                var fullName = player.fn + ' ' + player.ln;
                return (player.fn.match(regex) != null || player.ln.match(regex) != null || fullName.match(regex) != null);
            }
            else if (_this.searchString == '' && _this.teamfilter != '') {
                var teamfregex = new RegExp(_this.teamfilter, 'gi');
                return (player.tn.match(teamfregex) != null);
            }
            else {
                return player;
            }
        };
        this.spinner.hide();
        this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(function (state) {
            if (state.length > 0) {
                _this.isMobile = state[0];
            }
        });
        this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
                _this.darkMode_ext = _this.darkMode ? '-dark' : '';
            }
        });
    }
    RankemComponent.prototype.canDeactivate = function () {
        this.isLoading = false;
        return !this.orderChnage;
    };
    RankemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = true;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser !== null) {
            this.loginUserID = parseInt(this.currentUser.id);
            this.route.params.subscribe(function (params) {
                _this.parameters.league_id = params.league_id;
                _this.parameters.game_type = params.game_type;
                _this.parameters.lgm_id = (params.lgm_id != null) ? params.lgm_id : 0;
                if (_this.parameters.lgm_id == 0)
                    _this.newTeam = true;
                if (!_this.isNumeric(_this.parameters.league_id) || !_this.isNumeric(_this.parameters.lgm_id)) {
                    _this.router.navigate(['/lobby']);
                }
                _this.selectedteam = parseInt(_this.parameters.lgm_id);
                _this.getLeagueDetail();
            });
        }
        if (localStorage.getItem('currentUser') == null) {
            // redirect to login page
            window.location.href = "" + environment.SITE_URL + '/logout';
        }
    };
    RankemComponent.prototype.getLeagueDetail = function () {
        var _this = this;
        this.isLoading = true;
        this.rankemService.getLeagueDetail(this.parameters.league_id, this.loginUserID, this.parameters.lgm_id).subscribe(function (res) {
            _this.selectedPlayers = [];
            if (res.status == 0) {
                _this.router.navigate(['/lobby']);
            }
            _this.rankemData = res.entities;
            if (_this.parameters.lgm_id != 0) {
                var invalid_1 = true;
                if (_this.rankemData.standing.length <= 0) {
                    _this.rankemData.myTeams.filter(function (contest) {
                        if (contest.id == _this.parameters.lgm_id) {
                            invalid_1 = false;
                        }
                    });
                }
                else {
                    _this.rankemData.standing.filter(function (stand) {
                        if (stand.lgm_id == _this.parameters.lgm_id) {
                            invalid_1 = false;
                        }
                    });
                }
                if (invalid_1) {
                    _this.router.navigate(['/lobby']);
                }
            }
            if (_this.rankemData) {
                _this.playerList = _this.rankemData.players;
            }
            _this.game_type = _this.rankemData.league.lg_abbr;
            _this.total_number = _this.rankemData.total_player;
            _this.player_remainig = _this.rankemData.total_player;
            _this.showfpts = _this.rankemData.league.egs < Math.floor(Date.now() / 1000) ? true : false;
            if (_this.showfpts || _this.parameters.lgm_id > 0) {
                _this.newTeam = false;
            }
            if (_this.showfpts && !_this.parameters.lgm_id) {
                var data = { 'value': _this.rankemData.myTeams[0].id };
                _this.changeTeam(data);
            }
            if (_this.parameters.lgm_id > 0) {
                _this.selectedPlayers = _this.rankemData.ranked_player.slice();
            }
            _this.showMultiplier();
            _this.checkDisabled();
            _this.isLoading = false;
        });
    };
    RankemComponent.prototype.getInjuryAbbr = function (desc) {
        switch (desc) {
            case 'Out':
                return 'O';
            case 'Day-To-Day':
                return 'Q';
            case 'IR':
                return 'O';
            case 'IR-NR':
                return 'O';
            case 'IR-LT':
                return 'O';
            case 'QUESTIONABLE':
                return 'Q';
            case 'DOUBTFUL':
                return 'O';
            case 'OUT':
                return 'O';
            case 'INACTIVE':
                return 'O';
            case 'PUP-R':
                return 'O';
            case 'PUP-P':
                return 'O';
            case 'IR-R':
                return 'O';
            case 'IR':
                return 'O';
            case 'RESERVE-DNR':
                return 'O';
            case 'NFI-R':
                return 'O';
            case 'NFI-A':
                return 'O';
            case 'RESERVE-CEL':
                return 'O';
            case 'RESERVE-SUS':
                return 'O';
            case 'RESERVE-RET':
                return 'O';
            case 'RESERVE-EX':
                return 'O';
            case 'RESERVE-COVID-19':
                return 'O';
            case 'GTD':
                return 'D';
            case 'OUT':
                return 'O';
            case 'OFS':
                return 'O';
            case '60-Day IL':
                return 'O';
            case '15-Day IL':
                return 'O';
            case '10-Day IL':
                return 'O';
            case 'Out':
                return 'O';
            case '7-Day IL':
                return 'O';
            case 'Suspension':
                return 'O';
            case 'Paternity':
                return 'O';
            case 'Bereavement':
                return 'O';
            case 'COVID-19':
                return 'O';
            default:
                return desc.charAt(0);
        }
    };
    RankemComponent.prototype.openInfo = function (player, player_id, e) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        if ((player.infobox == null || player.infobox == 1) && player_id) {
            var filterddata = this.playerList.filter(function (player) { return _this.filterPlayers(player); });
            var playername = player.fn ? player.fn + ' ' + player.ln : player.pname.split(" ");
            this.dialog.open(Playerinfobox2Component, {
                width: this.isMobile ? '90%' : '70%',
                height: 'auto',
                autoFocus: false,
                data: {
                    isDraft: false,
                    league: {
                        game_id: this.rankemData.league.game_id,
                        id: this.rankemData.fantasy_lg_id,
                        abbr: this.rankemData.league.lg_abbr,
                        active_season_id: this.rankemData.league.season_id
                    },
                    lgm_id: 0,
                    players: filterddata,
                    player_data: { 'pp': player.pp ? player.pp : player.plrImage, 'fn': player.fn ? player.fn : playername[0], 'ln': player.ln ? player.ln : playername[1] },
                    player_id: player_id
                }
            });
        }
    };
    RankemComponent.prototype.selectPlayer = function (player) {
        var found = this.rankemData.ranked_player.some(function (el) { return el.id == player.id; });
        if (found == true) {
            player.is_hide = 1;
        }
        this.orderChnage = true;
        for (var i = 0; i < this.rankemData.ranked_player.length; i++) {
            var slot = this.rankemData.ranked_player[i];
            if (slot.id == 0 && found == false) {
                slot.id = parseInt(player.id);
                slot.proj = player.prj;
                slot.fpts = player.gp > 0 ? (player.fpts / player.gp) : player.fpts;
                slot.avg = player.gp > 0 ? (player.fpts / player.gp) : player.fpts;
                slot.tid = player.tid;
                slot.pname = player.fn + ' ' + player.ln;
                slot.plrImage = this.uploadURL + player.pp;
                slot.gp_id = player.pid;
                // slot.display_pn = slot.display_pn==undefined?slot.pn:slot.display_pn;
                //slot.pn = slot.pnMulti;
                slot.pick_rp = player.pn;
                slot.opn = player.opn;
                slot.start_time = player.form_gs;
                slot.tn = player.tn;
                player.is_hide = 1;
                this.player_remainig--;
                this.selectedPlayers.push(slot);
                //this.selectedPlayers.splice(i, 0, slot);
                break;
            }
        }
        this.checkDisabled();
        if (this.player_remainig == 0 && this.selectedteam == 0) {
            this.joinLeaguePopup();
        }
        this.showMultiplier();
    };
    RankemComponent.prototype.getLastName = function (player) {
        var temp = player.pname.split(' ');
        temp.splice(0, 1);
        return temp.join(' ');
    };
    RankemComponent.prototype.joinLeaguePopup = function (league, isQuickJoin) {
        var _this = this;
        if (league === void 0) { league = null; }
        if (isQuickJoin === void 0) { isQuickJoin = false; }
        this.disableButton = true;
        setTimeout(function () {
            _this.disableButton = false;
        }, 2000);
        this.orderChnage = false;
        if (this.selectedteam > 0) {
            this.sendRoster(this.rankemData.league, this.selectedteam);
            return true;
        }
        this.errors = '';
        if (league == null)
            league = this.rankemData.league;
        if (Number(league.entrants) - Number(league.joined_entrants) <= 0) {
            this.errors = 'League is already full';
            return false;
        }
        else if (this.rankemData.myTeams.length >= league.max_entries) {
            this.errors = 'You have already entered this contest with the maximum number of entries';
            return false;
        }
        this.tournamentService.getUserLocation(this.currentUser.id, function (locationData) {
            locationData['league_code'] = league.league_code;
            locationData['user_id'] = _this.currentUser.id;
            _this.sublgDetail = _this.tournamentService.getJoinPopUpData(locationData).subscribe(function (res) {
                if (typeof res !== 'undefined' && res.status === 'success') {
                    _this.joinLeagueData = res.entities;
                    if (_this.joinLeagueData && (Number(_this.joinLeagueData.balance) < Number(_this.joinLeagueData.league_fee)) && (!_this.joinLeagueData.hasTicket)) {
                        _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                            width: '500px',
                            data: { 'title': "Deposit", 'body': '', 'type': 'deposit_fee', 'league_type': league.league_type ? league.league_type : league.lg_abbr, 'name': league.name, 'balance_text': _this.joinLeagueData.balance_text, 'entry_fee': _this.joinLeagueData.entry_fee }
                        });
                        _this.confirmDialogRef.afterClosed()
                            .subscribe(function (res) {
                        });
                    }
                    else {
                        var remaining_people = Number(league.entrants) - Number(league.joined_entrants);
                        _this.leagueDialogRef = _this.dialog.open(LeagueRegPopupComponent, {
                            width: '500px',
                            data: { 'league_code': league.league_code, 'draft_type': 'rankem', 'result': _this.joinLeagueData, 'remaining_people': remaining_people, 'drafttype_id': 5 }
                        });
                        _this.leagueDialogRef.afterClosed()
                            .subscribe(function (res) {
                            if (res.status == 'success') {
                                if (isQuickJoin) {
                                    _this.quickContests.filter(function (contest) {
                                        if (contest.id == league.id) {
                                            contest.is_joined = 1;
                                        }
                                    });
                                    _this.newTeam = false;
                                }
                                _this.currentLgmId = res.my_team_id;
                                _this.sendRoster(league, res.my_team_id);
                            }
                        });
                    }
                }
                else {
                    _this.isLoading = false;
                    _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                        width: (res.type == 'age_18') ? '500px' : '800px',
                        data: { 'title': "Eligibility Warning", 'body': res.message, 'type': res.type }
                    });
                    _this.confirmDialogRef.afterClosed()
                        .subscribe(function (res) {
                        if (res) {
                        }
                    });
                }
            });
        });
    };
    RankemComponent.prototype.sendRoster = function (league, lgm_id) {
        var _this = this;
        if (league === void 0) { league = null; }
        if (lgm_id === void 0) { lgm_id = null; }
        this.errors = '';
        this.isLoading = true;
        if (league.egs == null)
            league.egs = parseInt(league.pro_game_start_time);
        if (this.player_remainig == 0 && this.isMyTeam && lgm_id > 0 && league.egs > Math.floor(Date.now() / 1000)) {
            var soreted_arr = this.roasterFix();
            var league_id = league.id;
            if (league.tournament_code != undefined && league.tournament_code != "") {
                league_id = league.league_id;
            }
            this._mainService.saveRankemRoster(league_id, lgm_id, league.game_id, soreted_arr).subscribe(function (state) {
                _this.orderChnage = false;
                if (state.status == 'success') {
                    _this.successMsg = state.message;
                    if (_this.newTeam) {
                        _this.showQuickJoin();
                    }
                    if (league.my_entries != null)
                        league.my_entries++;
                    league.joined_entrants = parseInt(league.joined_entrants) + 1;
                    setTimeout(function () {
                        _this.successMsg = "";
                    }, 5000);
                }
                else {
                    _this.errors = state.message;
                    setTimeout(function () {
                        _this.errors = "";
                    }, 5000);
                }
                _this.isLoading = false;
                if (!_this.newTeam && _this.visibleQuickJoin == false) {
                    var data = { 'value': lgm_id };
                    _this.changeTeam(data);
                }
            });
        }
        else {
            if (lgm_id == 0)
                this.errors = 'You haven\'t properly entered the contest yet.';
            if (!this.isMyTeam)
                this.errors = 'You don\'t own the team you\'re trying to edit.';
            if (this.mode != 'create' || this.rankemData.league.egs <= Math.floor(Date.now() / 1000))
                this.errors = 'The contest has already started.';
            if (this.rankemData.remaining > 0)
                this.errors = 'You are trying to submit an incomplete team.';
        }
    };
    RankemComponent.prototype.setSearch = function (event) {
        var _this = this;
        if (typeof event.value) {
            this.teamfilter = event.value;
        }
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function () {
            _this.searchString = event.target.value;
        }, 800);
    };
    RankemComponent.prototype.clearSearch = function () {
        this.searchString = '';
    };
    RankemComponent.prototype.removePlayer = function (player, event) {
        event.stopPropagation();
        var playerid = player.id;
        for (var i = 0; i < this.rankemData.players.length; i++) {
            if (this.rankemData.players[i].id == player.id) {
                this.rankemData.players[i].is_hide = 0;
                break;
            }
        }
        this.orderChnage = true;
        this.selectedPlayers.splice(this.selectedPlayers.findIndex(function (e) { return e.id == playerid; }), 1);
        player.pname = 'Select player';
        player.id = 0;
        player.proj = 0;
        player.tid = 0;
        player.plrImage = '';
        player.gp_id = 0;
        // player.pn = player.display_pn;
        // player.display_pn = null;
        player.is_hide = 0;
        this.player_remainig++;
        //this.rankemData.multiplier++;
        this.showMultiplier();
        this.checkDisabled();
    };
    RankemComponent.prototype.array_move = function (arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };
    RankemComponent.prototype.immutableMove = function (arr, from, to) {
        return arr.reduce(function (prev, current, idx, self) {
            if (from === to) {
                prev.push(current);
            }
            if (idx === from) {
                return prev;
            }
            if (from < to) {
                prev.push(current);
            }
            if (idx === to) {
                prev.push(self[from]);
            }
            if (from > to) {
                prev.push(current);
            }
            return prev;
        }, []);
    };
    RankemComponent.prototype.sortPlayers = function (type) {
        var _this = this;
        if (this.curSort == type)
            this.curDir = this.curDir * -1;
        this.curSort = type;
        switch (type) {
            case 'pos':
                this.playerList.sort(function (a, b) {
                    return (parseFloat(a.pn) < parseFloat(b.pn)) ? 1 * _this.curDir : -1 * _this.curDir;
                });
                break;
            case 'fpts':
                this.playerList.sort(function (a, b) {
                    return (parseFloat(a.fpts) < parseFloat(b.fpts)) ? 1 * _this.curDir : -1 * _this.curDir;
                });
                break;
            case 'proj':
                this.playerList.sort(function (a, b) {
                    return (parseFloat(a.proj) < parseFloat(b.proj)) ? 1 * _this.curDir : -1 * _this.curDir;
                });
                break;
            case 'fn':
                this.playerList.sort(function (a, b) {
                    return (a.fn + ' ' + a.ln < b.fn + '' + b.ln) ? 1 * _this.curDir : -1 * _this.curDir;
                });
                break;
        }
    };
    RankemComponent.prototype.changeTeam = function (event) {
        if (parseInt(event.value) > 0) {
            this.newTeam = false;
        }
        else {
            this.newTeam = true;
        }
        this.isLoading = true;
        this.selectedteam = parseInt(event.value);
        this.router.navigate(['/rankem/' + this.game_type + '/' + this.parameters.league_id + '/' + event.value]);
        this.isLoading = false;
    };
    RankemComponent.prototype.getPositionBG = function (position) {
        position = position.split(",")[0];
        var colors = {
            "QB": "#bac9e2",
            "RB": "#bae2ba",
            "WR": "#e2e1ba",
            "TE": "#e2baba",
            "DEF": "#bae2e0",
            "K": "#d8bae2",
            "FLEX": "rgba(146, 134, 44)",
            "C": "rgba(207, 93, 41)",
            "LW": "rgba(72, 175, 23)",
            "RW": "rgba(207, 189, 22)",
            "D": "rgba(71, 170, 162)",
            "G": "rgba(189, 23, 23)",
            "1B": "rgba(84, 45, 224)",
            "2B": "rgba(72, 179, 23)",
            "3B": "rgba(207, 189, 22)",
            "SS": "rgba(223, 27, 27)",
            "LF": "rgba(32, 180, 155)",
            "CF": "rgba(155, 32, 167)",
            "RF": "rgba(187, 38, 120)",
            "SP": "rgba(76, 153, 147)",
            "TG": "rgba(74, 79, 136)",
            "BN": "rgba(58, 131, 119)",
            "IR": "rgba(51, 109, 63)",
            "W": "rgba(167, 94, 46)",
            "F": "rgba(150, 56, 90)",
            "S": "rgba(54, 131, 33)",
            "MI": "rgba(60, 82, 54)",
            "OF": "rgba(148, 77, 139)",
            "DH": "rgba(97, 42, 56)",
            "UTIL": "rgba(70, 148, 148)",
            "P": "rgba(101, 131, 76)",
            "RP": "rgba(120, 155, 39)",
            "PG": "rgba(136, 34, 34)",
            "FG": "rgba(104, 134, 28)",
            "SG": "#8ae06b",
            "SF": "rgba(37, 50, 172)",
            "PF": "rgba(106, 39, 131)",
            "WR-TE": "#ff76149e"
        };
        if (typeof colors[position] != "undefined") {
            return colors[position];
        }
        else {
            return "#FFF";
        }
    };
    RankemComponent.prototype.openLeague = function (league_id, tournament_id) {
        var _this = this;
        var dialogRef = null;
        if (tournament_id == 0) {
            dialogRef = this.dialog.open(GamepreviewpopupComponent, {
                width: '800px',
                data: { league_id: league_id, 'pagename': 'rankem' },
                autoFocus: false
            });
        }
        else {
            dialogRef = this.dialog.open(TournamentpopupComponent, {
                width: '800px',
                data: {
                    league_id: league_id,
                    tournament_id: tournament_id
                },
                autoFocus: false
            });
        }
        dialogRef.afterClosed().subscribe(function (result) {
            if (result != undefined && result.route != undefined)
                _this.router.navigate(result.route);
        });
        dialogRef.componentInstance.closePopupAndNavigate.subscribe(function (route) {
            dialogRef.close({ 'route': [route] });
        });
    };
    RankemComponent.prototype.playerDisplay = function (player) {
        if (player.is_hide == 1) {
            return false;
        }
        else {
            var found = this.rankemData.ranked_player.some(function (el) { return el.id == player.id; });
            if (found == true) {
                player.is_hide = 1;
            }
            return !found;
        }
    };
    RankemComponent.prototype.roasterFix = function () {
        var element = this.playerrowele.nativeElement;
        var children = element.children;
        var rplen = this.rankemData.ranked_player.length;
        if (rplen != this.selectedPlayers.length) {
            this.errors = 'Please selecte all players';
            return false;
        }
        var ordered_roasterarray = [];
        var _loop_1 = function () {
            var player_id = children[i].dataset.player_id;
            this_1.selectedPlayers.filter(function (player) {
                if (player.id == player_id) {
                    var ordered_roaster = __assign({}, player);
                    ordered_roaster.id = player.id;
                    ordered_roaster.pick_rp = player.pick_rp;
                    ordered_roaster.fpts = player.fpts;
                    ordered_roaster.avg = player.avg;
                    ordered_roaster.proj = player.proj;
                    ordered_roaster.pname = player.pname;
                    ordered_roaster.plrImage = player.plrImage;
                    ordered_roaster.gp_id = player.gp_id;
                    ordered_roaster.pn = i < rplen - 2 ? i + 1 : 'R';
                    ordered_roasterarray.push(ordered_roaster);
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < children.length; i++) {
            _loop_1();
        }
        return ordered_roasterarray;
    };
    RankemComponent.prototype.showMultiplier = function () {
        this.multiplier = '';
        for (var i = 0; i < this.rankemData.ranked_player.length; i++) {
            var slot = this.rankemData.ranked_player[i];
            if (slot.id == 0) {
                this.multiplier = slot.pnMulti;
                break;
            }
        }
    };
    RankemComponent.prototype.isNumeric = function (num) {
        return (typeof (num) === 'number' || typeof (num) === "string" && num.trim() !== '') && !isNaN(num);
    };
    RankemComponent.prototype.checkDisabled = function () {
        if (this.player_remainig > 0 || this.rankemData.league.egs < Math.floor(Date.now() / 1000)) {
            this.disableButton = true;
        }
        else {
            if (this.orderChnage)
                this.disableButton = false;
            else
                this.disableButton = true;
        }
    };
    RankemComponent.prototype.showQuickJoin = function () {
        var _this = this;
        this._mainService.rankemQuickJoin(this.rankemData.league.lg_abbr, this.rankemData.position_set, this.loginUserID).subscribe(function (state) {
            if (state.status == 'success' && (state.entities.tournamentList.length || state.entities.contestList.length)) {
                state.entities.tournamentList.forEach(function (contest) {
                    contest.my_entries = (contest.league_joined_users != null) ? contest.league_joined_users.split(',').filter(function (user) { return parseInt(user) == _this.loginUserID; }).length : 0;
                    contest.confirm = 0;
                });
                state.entities.contestList.forEach(function (contest2) {
                    contest2.my_entries = (contest2.league_joined_users != null) ? contest2.league_joined_users.split(',').filter(function (user) { return parseInt(user) == _this.loginUserID; }).length : 0;
                    contest2.confirm = 0;
                });
                var allcontests = state.entities.tournamentList.concat(state.entities.contestList);
                // const allcontests = state.entities.contestList;
                if (allcontests.length) {
                    _this.quickContests = allcontests;
                    _this.visibleQuickJoin = true;
                    _this.dialogRef2 = _this.dialog.open(_this.quickJoin);
                    _this.dialogRef2.afterClosed().subscribe(function (result) {
                        if (result !== undefined) {
                            if (result.close == 'yes') {
                                _this.router.navigate(['/rankem/' + result.league_type + '/' + result.id + '/0']);
                            }
                            else if (result === 'no') {
                                _this.router.navigate(['/lobby']);
                            }
                        }
                        else {
                            _this.router.navigate(['/lobby']);
                        }
                    });
                }
            }
            else {
                _this.router.navigate(['/rankem/' + _this.rankemData.league.lg_abbr + '/' + _this.parameters.league_id + '/0']);
            }
        });
    };
    RankemComponent.prototype.quickJoinProcess = function (contest) {
        contest.confirm = (contest.confirm == 0) ? 1 : 0; // 2-step join confirmation
        if (!contest.confirm) {
            this.joinLeaguePopup(contest, true);
        }
    };
    RankemComponent.prototype.redirect = function (contest) {
        if (contest.id != this.parameters.league_id) {
            this.isLoading = true;
        }
        var league_id = contest.id;
        if (contest.tournament_code != undefined && contest.tournament_code != "") {
            league_id = contest.league_id;
        }
        var data = { 'close': 'yes', 'league_type': contest.league_type, 'id': league_id };
        this.dialogRef2.close(data);
        this.visibleQuickJoin = false;
    };
    RankemComponent.prototype.selectStanding = function (lgm_id) {
        this.router.navigate(['/rankem/' + this.game_type + '/' + this.parameters.league_id + '/' + lgm_id]);
        this.curTabClass = 'myteam';
        this.curTab = 'myteam';
        this.tabChange('0');
    };
    RankemComponent.prototype.tabChange = function (tab) {
        var tabGroup = this.limitDiv;
        if (tab != 'null')
            this.goToSpecificTabIndex(tab);
        if (tabGroup.selectedIndex == 1) {
        }
    };
    RankemComponent.prototype.goToSpecificTabIndex = function (currentTab) {
        var tabGroup = this.limitDiv;
        if (!tabGroup || !(tabGroup instanceof MatTabGroup))
            return;
        if (tabGroup.selectedIndex != currentTab) {
            tabGroup.selectedIndex = currentTab;
        }
    };
    RankemComponent.prototype.getClassName = function () {
        var elementh = this.ade.nativeElement.offsetHeight;
        return elementh > 1 ? true : false;
    };
    return RankemComponent;
}());
export { RankemComponent };
